import { useCallback, useEffect, useState } from "react";
import axios from "../../../api/apiClient";
import { domain, token } from "../../Security";
import loadingSpinner from '../../../assets/loading.gif';

import CloseIcon from "@mui/icons-material/Close";
import { CreateTable } from "../components/CreateTable";

export function ViewEventsMemoForm({ isOpen,
  onClose,
  eventDate,
  editHandleClick,
  deleteHandleClick,
  isUpdate,
  setIsUpdate,
  userAccess
}) {
  var header = [
    "Description",
    "Date From",
    "Date To",
    "Content",
    "Image",
    "",
  ]
  var accessor = [
    "title",
    "dateFrom",
    "dateTo",
    "description",
    "content",
    "manage"
  ]

  if (userAccess) {
    if (userAccess.description !== "Admin"
      && userAccess.description !== "HR Head"
      && userAccess.description !== "HR Assistant"
      && userAccess.description !== "HR Assistant2"
      && userAccess.description !== "HR Assistant3"
    ) {
      header = [
        "Description",
        "Date From",
        "Date To",
        "Content",
        "Image",
      ];

      accessor = [
        "title",
        "dateFrom",
        "dateTo",
        "description",
        "content",
      ]
    }
  }

  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState(false);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/Memo";

    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      let filteredData = [];
      response.data.forEach(memo => {
        const memoDateFrom = new Date(memo.dateFrom);
        const memoDateTo = new Date(memo.dateTo);
        const thisDate = new Date();

        // Strip time component by setting to midnight
        const thisDateOnly = new Date(thisDate.setHours(0, 0, 0, 0));
        const memoDateFromOnly = new Date(memoDateFrom.setHours(0, 0, 0, 0));
        const memoDateToOnly = new Date(memoDateTo.setHours(23, 59, 59, 999));

        if (thisDateOnly >= memoDateFromOnly && thisDateOnly <= memoDateToOnly) {
          filteredData.push(memo);
        }
      });

      setRequests(filteredData); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
      setIsUpdate(false);
    }
  }, [setIsUpdate]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [fetchData, isOpen, isUpdate]);

  const handleClose = () => {
    onClose();
    setRequests([]);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Memo/s</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body loan-history-table user-template-body">
              <div className="users-table container" style={{ overflow: "unset" }}>
                <CreateTable
                  dataList={requests ? requests : []}
                  dataHeader={header}
                  dataAccessor={accessor}
                  editHandleClick={editHandleClick}
                  deleteHandleClick={deleteHandleClick}
                />
                {requests.length > 0 ? (
                  <div></div>
                )
                  :
                  (
                    <div>
                      {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                          <img src={loadingSpinner} alt="Loading..." />
                        </div>
                      ) : (
                        <div> {/*<p>No records to display</p>*/}</div>
                      )
                      }
                    </div>
                  )}
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
